import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import {
  ReaCheckResponse,
  ReaCheckViewState,
  ReaExplotacion,
} from 'src/app/models/fincas/rea.model';

/**
 * Shows the initial REA check and emits the selected REA when several options exist.
 */
@Component({
  selector: 'app-rea-import-check-selection',
  templateUrl: './rea-import-check-selection.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReaImportCheckSelectionComponent {
  @Input()
  public check: ReaCheckResponse | null = null;

  @Input()
  public hasImportResult = false;

  @Input()
  public selectedRea = '';

  @Input()
  public availableExplotaciones: ReaExplotacion[] = [];

  @Input()
  public invalidSelectedReaMessage = '';

  @Input()
  public viewState: ReaCheckViewState = {
    title: 'Comprobación inicial',
    countLabel: '0 REA encontrados',
    notice: '',
    confirmedReaLabel: '',
    emptyLabel: 'No se han encontrado REA asociados para importar.',
    providedReaLabel: 'Se usará el REA indicado para continuar la importación.',
    canContinueWithProvidedRea: false,
  };

  @Output()
  public readonly selectedReaChange = new EventEmitter<string>();

  public exploitationOptionLabel(explotacion: ReaExplotacion): string {
    const communityLabel = explotacion.caExplotacion ? explotacion.caExplotacion : 'no disponible';

    return 'Registro REA: ' + explotacion.codigoRea + ' - Comunidad: ' + communityLabel;
  }

  public onSelectedReaChange(event: Event): void {
    const target = event.target as HTMLSelectElement | null;

    this.selectedReaChange.emit(target?.value ?? '');
  }
}
